import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import Store from './store/store';
import NotificationProvider from "./provider/NotificationProvider";
import { CommunitySettingsProvider } from "./context/CommunitySettingsContext";
import { setSessionExpiredHandler } from './utils/sessionExpiry';
import {createContext} from "react";
const store = new Store();

// Коли будь-який запит отримує 401 (сесія протухла), скидаємо auth-стан —
// Home.jsx (observer) відразу рендерить <Login/> замість "зомбі-сесії".
setSessionExpiredHandler(() => {
    if (store.isAuth) store.logOff();
});
export const Context = createContext({
    store,
})

createRoot(document.getElementById('root')).render(
    <NotificationProvider>
        <Context.Provider value={{store}}>
            <CommunitySettingsProvider>
                <App/>
            </CommunitySettingsProvider>
        </Context.Provider>
    </NotificationProvider>
)
